import { ThemeButton } from "../ThemeButton/ThemeButton";

export const PublicInvitationLayout = ({ children }) => {
   return (
      <div className="h-dvh overflow-y-auto flex flex-col font-sans transition-colors duration-200">
         <div className="flex items-center justify-end gap-6 p-6!">
            <ThemeButton />
         </div>
         <div className="flex-1 flex items-start justify-center p-4 pt-20">
            {children}
         </div>
      </div>
   );
};